export const navLinks = [
  'Home',
  'About',
  'Sectors',
  'Services',
  'Sub a proposal',
  'Contact',
];
